import {result} from 'lodash';
import React from 'react';
import FORMULAS from '../../../../utils/fomulas';
import BasePipelineStepComponent from '../base_pipeline_step';

export default class AddColumnStepComponent extends BasePipelineStepComponent {
    icon = 'transformations-add-col';

    formulaSelect = null;
    columnSelect = null;
    amountInput = null;

    constructor(props) {
        super(props);

        Object.assign(this.state, {
            amount: props.step.getArg('amount'),
        });
    }

    updateStep(ev, step) {
        const {value} = ev.target;
        switch (ev.target) {
            case this.formulaSelect:
                step.formula = FORMULAS[value];
                break;
            case this.amountInput:
                step.setArg('amount', parseFloat(value));
                break;
            case this.columnSelect:
                step.setArg('srcColumn', value);
                break;
            case this.nameInput:
                step.setArg('columnName', value);
                break;
            default:
                break;
        }
    }

    renderHeader() {
        return (
            <div className="pipeline-step-text pipeline-highlight">
                Add Column
            </div>
        );
    }

    renderForm() {
        const {tempStep, results, amount} = this.state;
        return (
            <>
                <form onSubmit={this.onSave}>
                    <label className="label">
                        New Column Name
                    </label>
                    <input
                        type="text"
                        className="input w-input"
                        value={tempStep.getArg('columnName')}
                        onChange={this.onChange}
                        ref={(input) => { this.nameInput = input; }}
                        placeholder="new column name"
                    />
                    <label className="label">
                        Formula Type
                    </label>
                    <select
                        className="select-field w-select"
                        value={result(tempStep.formula, 'name', '')}
                        onChange={this.onChange}
                        ref={(input) => { this.formulaSelect = input; }}
                    >
                        {Object.values(FORMULAS).map(formula => (
                            <option
                                key={formula.name}
                                value={formula.name}
                            >
                                {formula.label}
                            </option>
                        ))}
                    </select>
                    <label className="label">
                        Using Column
                    </label>
                    <select
                        className="select-field w-select"
                        value={result(tempStep.formulaArgs, 'srcColumn', '')}
                        onChange={this.onChange}
                        ref={(input) => { this.columnSelect = input; }}
                    >
                        {results.before.columns.map(col => (
                            <option
                                key={col.id}
                                value={col.id}
                            >
                                {col.label}
                            </option>
                        ))}
                    </select>
                    {result(tempStep.formula, 'needsArgs') && (
                        <>
                            <label className="label">
                                Amount
                            </label>
                            <input
                                type="text"
                                className="input w-input"
                                value={amount}
                                onChange={this.onChange}
                                ref={(input) => { this.amountInput = input; }}
                                placeholder="amount"
                            />
                        </>
                    )}
                </form>
                <div className="pipeline-step-form-help-text">
                    Use this step to add a new column. In this prototype only
                    simple math operations and Running Total are available.
                </div>
            </>
        );
    }

    renderValue() {
        return (
            <div className="pipeline-step-text pipeline-highlight">
                Added Column <span className="column-value">{this.props.step.getDisplay()}</span>
            </div>
        );
    }
}
